import React from 'react';
import { WithSearch } from '@elastic/react-search-ui';
import JobCardList from './JobCardList';
import { JobResult } from '../types/job';

export const ElasticResultsWrapper: React.FC = () => (
    <WithSearch mapContextToProps={({ results, isLoading }) => ({ results, isLoading })}>
      {({ results, isLoading }: { results: JobResult[]; isLoading: boolean }) => {
        if (isLoading) return <div className="loading-wrapper"><p>Loading jobs…</p></div>;
        if (!results || results.length === 0) return <div className="loading-wrapper"><p>No jobs found.</p></div>;
        return <JobCardList results={results} />;
      }}
    </WithSearch>
);
